import React from 'react';

const ArrowUpRight = () => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.66699 11.6032L11.3337 4.93652" stroke="#2B9AF4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4.66699 4.93652H11.3337V11.6032" stroke="#2B9AF4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default ArrowUpRight;
